export default __webpack_public_path__ + "static/media/br.e39316c9.png";